export const CHART_COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#fe00ee',
  '#7bad7e',
  '#6551a9',
  '#3745bf',
  '#24AC99',
  '#98fb98',
  '#ee82ee',
  '#ffa07a',
  '#ff1493',
  '#f0e68c',
  '#a52a2a',
  '#ffa500',
  '#ff4500',
  '#00ff00',
];

export const PIE_CHART_COLORS = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF',
  '#FF9F40',
  '#FF5733',
  '#C70039',
  '#900C3F',
  '#581845',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#fe00ee',
  '#7bad7e',
  '#6551a9',
  '#3745bf',
  '#24AC99',
  '#98fb98',
  '#ee82ee',
  '#ffa07a',
  '#ff1493',
  '#f0e68c',
  '#a52a2a',
  '#ffa500',
  '#ff4500',
  '#00ff00',
];

/**
 * Every color currently defined inline across the app, gathered in one place.
 * Values are normalized hex (8-digit #RRGGBBAA where an alpha channel was used).
 * NOTE: not yet wired into call sites — this is the single-source-of-truth gather step.
 */
export const SITE_COLORS = {
  // ── Brand & login ──
  BRAND_NAVY: '#0C2646', // primary.main (light mode) + login gradient start
  BRAND_TEAL: '#185A7D', // former primary / brand teal
  MIDNIGHT_BLUE: '#152e4c', // login gradient mid-stop
  SKY_CYAN: '#00A6E2', // login gradient end / "/safety" accent
  SKY_CYAN_ACCENT: '#0078a8',
  CREAM: '#F5F0EA', // login right-panel background
  BRAND_BLUE_LIGHT: '#90CAF9', // primary.main (dark mode)
  CORNFLOWER: '#64B5F6', // accent fallback

  // ── Blues (tables / panels / reports) ──
  SKY_BLUE: '#7DB7ED', // ShaftClearance bar
  BLUE_500: '#2196F3',
  BLUE_700: '#1976D2',
  BLUE_900: '#0D47A1',
  PALE_BLUE_GREY: '#E1E7EC',
  BLUE_GREY: '#90A4AE',
  BLUE: '#0000FF', // CSS 'blue' keyword

  // ── Neutrals ──
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  DARK_SURFACE: '#2E2E2E', // dark-mode surface
  GRAPHITE: '#222222',
  BORDER_GREY: '#9B9B9B', // dialog / borders
  MID_GREY: '#666666', // secondary.main
  GREY_999: '#999999', // scrollbar
  GREY_888: '#888888',
  GREY_555: '#555555',
  GREY_CCC: '#CCCCCC',
  GREY_808: '#808080', // CSS 'gray'/'grey' keyword
  GREY_51: '#515151', // was rgba(81,81,81,1)
  OLIVE: '#778844',

  // ── Status / vivid ──
  RED: '#FF0000', // 'red' keyword + #f00
  DARK_RED: '#C80000', // rgb(200,0,0)
  SALMON: '#FF6666', // #f66
  PALE_RED: '#FEBFBE',
  GREEN: '#008000', // CSS 'green' keyword (NOT pure green — spec value)
  GREEN_MID: '#009100', // rgb(0,145,0)
  LIME: '#00FF00', // 'lime' keyword + #0f0
  YELLOW: '#FFFF00', // 'yellow' keyword + #ff0
  BRIGHT_YELLOW: '#F0F000', // rgb(240,240,0)
  ORANGE: '#FFA500', // 'orange' keyword
  ORANGE_PURE: '#FF8000', // rgb(255,128,0)
  AMBER: '#FF9900', // #f90
  CYAN: '#00FFFF', // 'cyan' keyword + #0ff
  MAGENTA: '#FF00FF', // rgb(255,0,255)
  PURPLE: '#800080', // 'purple' keyword

  // ── Overlays / alpha (8-digit #RRGGBBAA) ──
  OVERLAY_BLACK_50: '#00000080', // App backdrop (light) + rgba(0,0,0,0.5)
  OVERLAY_DARK_50: '#44444490', // App backdrop (dark)
  OVERLAY_GREY_67: '#777777AA',
  WHITE_85: '#FFFFFFD9',
  WHITE_75: '#FFFFFFBF', // login paragraph
  WHITE_23: '#FFFFFF3B',
  WHITE_20: '#FFFFFF33',
  BLACK_85: '#000000D9',
  BLACK_60: '#00000099',
  BLACK_40: '#00000066',
  DARK_SURFACE_20: '#1E1E1E33', // rgba(30,30,30,0.2)

  // ── Special ──
  TRANSPARENT: 'transparent',

  // Light mode colors from demo site
  LM_GREEN: '#16a34a',
  LM_GREEN_ACCENT: '#e8f1e6',
  LM_RED: '#dc2626',
  LM_ORANGE: '#d97706',
  LM_GREY_ACCENT: '#b6bec8',
  LM_NAVY_ACCENT: '#152e4c',
  LM_TEXT_DARK: '#1a2532',
} as const;
